import Layout from '@/components/layout/Layout.vue'
import CreateForm from '@/views/sys/admin/create/Create.vue'
import OnlinePage from '@/views/sys/admin/online/Online.vue'
import { getAdmins, deleteAdmins } from '@/api/admin'
import { getRoles } from '@/api/open'
import Helper from '@/utils/helper'

const columns = [
    { title: 'ID', dataIndex: 'id' },
    { title: '账号', dataIndex: 'username' },
    { title: '姓名', dataIndex: 'name' },
    { title: '角色', dataIndex: 'role_name' },
    { title: '优化师', dataIndex: 'workers' , scopedSlots: { customRender: 'workers' } },
    { title: '小组', dataIndex: 'teams' , scopedSlots: { customRender: 'teams' } },
    { title: '绑定主体', dataIndex: 'corporations' , scopedSlots: { customRender: 'corporations' } },
    { title: '状态', dataIndex: 'enabled' , scopedSlots: { customRender: 'status' } },
    { title: '在线', scopedSlots: { customRender: 'online' } },
    { title: '操作', dataIndex: '', scopedSlots: { customRender: 'action' } }
]

export default {
    name: 'admins',
    components: {
        Layout,
        CreateForm,
        OnlinePage,
    },
    data () {
        return {
            helper: Helper,
            data: [],
            pagination: { defaultPageSize: 20 },
            loading: false,
            selectedRowKeys: [],
            columns,
            model: {},
            showForm: false,
            showOnlinePage: false,
            advanced: false,
            queryParam: {},
            roles: {},
        }
    },
    mounted() {
        this.getData()
        getRoles().then(res => {
            this.roles = res.data.list || {}
        })
    },
    methods: {
        create(record) {
            this.model = record.id ? Object.assign({}, record) : {
                query_limit: false,
                enabled: true
            }
            this.showForm = true
        },
        showOnline(record) {
            this.model = Object.assign({}, record)
            this.showOnlinePage = true
        },
        destroy(record) {
            const del = ids => {
                deleteAdmins(ids).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        handleTableChange(pagination) {
            const pager = { ...this.pagination }
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = { ...this.pagination }
            const json = Object.assign({}, this.queryParam, {
                page: pagination.current,
                page_size: pagination.defaultPageSize
            })

            if (json.date && json.date.length > 0) {
                json.started_at = json.date[0].format('YYYY-MM-DD')
                json.finished_at = json.date[1].format('YYYY-MM-DD')
                delete json.date
            }

            getAdmins(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('AdminController', route)
        },
    }
}
